import axios from 'axios';
import store from '../store';

function deleteTopics (topicIds) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/topic/delete', {topicIds: topicIds});
}

function getRouteNames (topicIds) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/topic/getRouteNames', {topicIds: topicIds});
}

export {
  deleteTopics,
  getRouteNames
};



// WEBPACK FOOTER //
// ./src/services/TopicService.js